export default {
  addressCodes: {
    // 省份代码 (前2位)
    11: "北京市",
    12: "天津市",
    13: "河北省",
    14: "山西省",
    15: "内蒙古自治区",
    21: "辽宁省",
    22: "吉林省",
    23: "黑龙江省",
    31: "上海市",
    32: "江苏省",
    33: "浙江省",
    34: "安徽省",
    35: "福建省",
    36: "江西省",
    37: "山东省",
    41: "河南省",
    42: "湖北省",
    43: "湖南省",
    44: "广东省",
    45: "广西壮族自治区",
    46: "海南省",
    50: "重庆市",
    51: "四川省",
    52: "贵州省",
    53: "云南省",
    54: "西藏自治区",
    61: "陕西省",
    62: "甘肃省",
    63: "青海省",
    64: "宁夏回族自治区",
    65: "新疆维吾尔自治区",
    71: "台湾省",
    81: "香港特别行政区",
    82: "澳门特别行政区",

    // 城市代码 (前4位) - 包含新旧代码
    // 北京市
    1101: "北京市",
    1100: "北京市", // 旧代码

    // 天津市
    1201: "天津市",
    1200: "天津市", // 旧代码

    // 河北省
    1301: "石家庄市",
    1302: "唐山市",
    1303: "秦皇岛市",
    1304: "邯郸市",
    1305: "邢台市",
    1306: "保定市",
    1307: "张家口市",
    1308: "承德市",
    1309: "沧州市",
    1310: "廊坊市",
    1311: "衡水市",

    // 山西省 - 新旧代码对照
    1401: "太原市",
    1402: "大同市",
    1403: "阳泉市",
    1404: "长治市",
    1405: "晋城市",
    1406: "朔州市",
    1407: "晋中市",
    1408: "运城市",
    1409: "忻州市",
    1410: "临汾市", // 新代码 (2000年后)
    1411: "吕梁市",
    
    // 山西省旧代码 (2000年前)
    1423: "忻州市",
    1424: "晋中市",
    1426: "临汾市",
    1427: "运城市",
    1430: "吕梁市",

    // 内蒙古自治区
    1501: "呼和浩特市",
    1502: "包头市",
    1503: "乌海市",
    1504: "赤峰市",
    1505: "通辽市",
    1506: "鄂尔多斯市",
    1507: "呼伦贝尔市",
    1508: "巴彦淖尔市",
    1509: "乌兰察布市",
    
    // 内蒙古旧代码
    1521: "呼伦贝尔市", // 现呼伦贝尔市
    1522: "兴安盟",
    1523: "通辽市", // 现通辽市
    1525: "锡林郭勒盟",
    1526: "乌兰察布市", // 现乌兰察布市
    1527: "鄂尔多斯市", // 现鄂尔多斯市
    1528: "巴彦淖尔市", // 现巴彦淖尔市
    1529: "阿拉善盟",

    // 辽宁省
    2101: "沈阳市",
    2102: "大连市",
    2103: "鞍山市",
    2104: "抚顺市",
    2105: "本溪市",
    2106: "丹东市",
    2107: "锦州市",
    2108: "营口市",
    2109: "阜新市",
    2110: "辽阳市",
    2111: "盘锦市",
    2112: "铁岭市",
    2113: "朝阳市",
    2114: "葫芦岛市",
    
    // 辽宁省旧代码
    2121: "铁岭市", // 现铁岭市
    2122: "朝阳市", // 现朝阳市

    // 吉林省
    2201: "长春市",
    2202: "吉林市",
    2203: "四平市",
    2204: "辽源市",
    2205: "通化市",
    2206: "白山市",
    2207: "松原市",
    2208: "白城市",
    
    // 吉林省旧代码
    2223: "白城市", // 现白城市
    2224: "延边朝鲜族自治州",

    // 黑龙江省
    2301: "哈尔滨市",
    2302: "齐齐哈尔市",
    2303: "鸡西市",
    2304: "鹤岗市",
    2305: "双鸭山市",
    2306: "大庆市",
    2307: "伊春市",
    2308: "佳木斯市",
    2309: "七台河市",
    2310: "牡丹江市",
    2311: "黑河市",
    2312: "绥化市",
    
    // 黑龙江省旧代码
    2321: "松花江地区", // 已撤销
    2323: "绥化市", // 现绥化市
    2326: "黑河市", // 现黑河市
    2327: "大兴安岭地区",

    // 上海市
    3101: "上海市",
    3100: "上海市", // 旧代码

    // 江苏省
    3201: "南京市",
    3202: "无锡市",
    3203: "徐州市",
    3204: "常州市",
    3205: "苏州市",
    3206: "南通市",
    3207: "连云港市",
    3208: "淮安市",
    3209: "盐城市",
    3210: "扬州市",
    3211: "镇江市",
    3212: "泰州市",
    3213: "宿迁市",

    // 浙江省
    3301: "杭州市",
    3302: "宁波市",
    3303: "温州市",
    3304: "嘉兴市",
    3305: "湖州市",
    3306: "绍兴市",
    3307: "金华市",
    3308: "衢州市",
    3309: "舟山市",
    3310: "台州市",
    3311: "丽水市",
    
    // 浙江省旧代码
    3325: "丽水市", // 现丽水市
    3326: "台州市", // 现台州市

    // 安徽省
    3401: "合肥市",
    3402: "芜湖市",
    3403: "蚌埠市",
    3404: "淮南市",
    3405: "马鞍山市",
    3406: "淮北市",
    3407: "铜陵市",
    3408: "安庆市",
    3410: "黄山市",
    3411: "滁州市",
    3412: "阜阳市",
    3413: "宿州市",
    3415: "六安市",
    3416: "亳州市",
    3417: "池州市",
    3418: "宣城市",
    
    // 安徽省旧代码
    3421: "阜阳市", // 现阜阳市
    3422: "宿州市", // 现宿州市
    3424: "六安市", // 现六安市
    3425: "宣城市", // 现宣城市
    3429: "池州市", // 现池州市

    // 福建省
    3501: "福州市",
    3502: "厦门市",
    3503: "莆田市",
    3504: "三明市",
    3505: "泉州市",
    3506: "漳州市",
    3507: "南平市",
    3508: "龙岩市",
    3509: "宁德市",

    // 江西省
    3601: "南昌市",
    3602: "景德镇市",
    3603: "萍乡市",
    3604: "九江市",
    3605: "新余市",
    3606: "鹰潭市",
    3607: "赣州市",
    3608: "吉安市",
    3609: "宜春市",
    3610: "抚州市",
    3611: "上饶市",
    
    // 江西省旧代码
    3621: "赣州市", // 现赣州市
    3622: "宜春市", // 现宜春市
    3623: "上饶市", // 现上饶市
    3624: "吉安市", // 现吉安市
    3625: "抚州市", // 现抚州市

    // 山东省
    3701: "济南市",
    3702: "青岛市",
    3703: "淄博市",
    3704: "枣庄市",
    3705: "东营市",
    3706: "烟台市",
    3707: "潍坊市",
    3708: "济宁市",
    3709: "泰安市",
    3710: "威海市",
    3711: "日照市",
    3713: "临沂市",
    3714: "德州市",
    3715: "聊城市",
    3716: "滨州市",
    3717: "菏泽市",
    
    // 山东省旧代码
    3723: "滨州市", // 现滨州市
    3724: "德州市", // 现德州市
    3725: "聊城市", // 现聊城市
    3728: "临沂市", // 现临沂市
    3729: "菏泽市", // 现菏泽市

    // 河南省
    4101: "郑州市",
    4102: "开封市",
    4103: "洛阳市",
    4104: "平顶山市",
    4105: "安阳市",
    4106: "鹤壁市",
    4107: "新乡市",
    4108: "焦作市",
    4109: "濮阳市",
    4110: "许昌市",
    4111: "漯河市",
    4112: "三门峡市",
    4113: "南阳市",
    4114: "商丘市",
    4115: "信阳市",
    4116: "周口市",
    4117: "驻马店市",
    
    // 河南省旧代码
    4123: "商丘市", // 现商丘市
    4127: "周口市", // 现周口市
    4128: "驻马店市", // 现驻马店市
    4129: "南阳市", // 现南阳市
    4130: "信阳市", // 现信阳市

    // 湖北省
    4201: "武汉市",
    4202: "黄石市",
    4203: "十堰市",
    4205: "宜昌市",
    4206: "襄阳市",
    4207: "鄂州市",
    4208: "荆门市",
    4209: "孝感市",
    4210: "荆州市",
    4211: "黄冈市",
    4212: "咸宁市",
    4213: "随州市",
    
    // 湖北省旧代码
    4221: "黄冈市", // 现黄冈市
    4222: "孝感市", // 现孝感市
    4223: "咸宁市", // 现咸宁市
    4224: "荆州市", // 现荆州市
    4226: "郧阳地区", // 已撤销，并入十堰市
    4228: "恩施土家族苗族自治州",
    4229: "省直辖行政单位",

    // 湖南省
    4301: "长沙市",
    4302: "株洲市",
    4303: "湘潭市",
    4304: "衡阳市",
    4305: "邵阳市",
    4306: "岳阳市",
    4307: "常德市",
    4308: "张家界市",
    4309: "益阳市",
    4310: "郴州市",
    4311: "永州市",
    4312: "怀化市",
    4313: "娄底市",
    
    // 湖南省旧代码
    4323: "益阳市", // 现益阳市
    4325: "娄底市", // 现娄底市
    4328: "郴州市", // 现郴州市
    4329: "永州市", // 现永州市
    4330: "怀化市", // 现怀化市
    4331: "湘西土家族苗族自治州",

    // 广东省
    4401: "广州市",
    4402: "韶关市",
    4403: "深圳市",
    4404: "珠海市",
    4405: "汕头市",
    4406: "佛山市",
    4407: "江门市",
    4408: "湛江市",
    4409: "茂名市",
    4412: "肇庆市",
    4413: "惠州市",
    4414: "梅州市",
    4415: "汕尾市",
    4416: "河源市",
    4417: "阳江市",
    4418: "清远市",
    4419: "东莞市",
    4420: "中山市",
    4451: "潮州市",
    4452: "揭阳市",
    4453: "云浮市",
    
    // 广东省旧代码
    4428: "肇庆市", // 现肇庆市
    4429: "湛江市", // 现湛江市
    4430: "海南省", // 现海南省

    // 广西壮族自治区
    4501: "南宁市",
    4502: "柳州市",
    4503: "桂林市",
    4504: "梧州市",
    4505: "北海市",
    4506: "防城港市",
    4507: "钦州市",
    4508: "贵港市",
    4509: "玉林市",
    4510: "百色市",
    4511: "贺州市",
    4512: "河池市",
    4513: "来宾市",
    4514: "崇左市",
    
    // 广西旧代码
    4521: "崇左市", // 现崇左市
    4522: "来宾市", // 现来宾市
    4523: "桂林地区", // 已撤销
    4524: "梧州地区", // 已撤销
    4525: "玉林市", // 现玉林市
    4526: "百色市", // 现百色市
    4527: "河池市", // 现河池市
    4528: "钦州市", // 现钦州市

    // 海南省
    4601: "海口市",
    4602: "三亚市",
    4603: "三沙市",
    4604: "儋州市",

    // 重庆市
    5001: "重庆市",
    5102: "重庆市", // 旧代码 (1997年前属四川省)

    // 四川省
    5101: "成都市",
    5103: "自贡市",
    5104: "攀枝花市",
    5105: "泸州市",
    5106: "德阳市",
    5107: "绵阳市",
    5108: "广元市",
    5109: "遂宁市",
    5110: "内江市",
    5111: "乐山市",
    5113: "南充市",
    5114: "眉山市",
    5115: "宜宾市",
    5116: "广安市",
    5117: "达州市",
    5118: "雅安市",
    5119: "巴中市",
    5120: "资阳市",
    
    // 四川省旧代码
    5129: "达州市", // 现达州市
    5130: "雅安市", // 现雅安市
    5134: "凉山彝族自治州",
    5137: "巴中市", // 现巴中市
    5138: "眉山市", // 现眉山市
    5139: "资阳市", // 现资阳市

    // 贵州省
    5201: "贵阳市",
    5202: "六盘水市",
    5203: "遵义市",
    5204: "安顺市",
    5223: "黔西南布依族苗族自治州",
    5226: "黔东南苗族侗族自治州",
    5227: "黔南布依族苗族自治州",
    
    // 贵州省旧代码
    5221: "遵义市", // 现遵义市
    5222: "铜仁市", // 现铜仁市
    5224: "毕节市", // 现毕节市
    5225: "安顺市", // 现安顺市

    // 云南省
    5301: "昆明市",
    5303: "曲靖市",
    5304: "玉溪市",
    5305: "保山市",
    5306: "昭通市",
    5307: "丽江市",
    5308: "普洱市",
    5309: "临沧市",
    
    // 云南省旧代码
    5321: "昭通市", // 现昭通市
    5322: "曲靖市", // 现曲靖市
    5323: "楚雄彝族自治州",
    5324: "玉溪市", // 现玉溪市
    5325: "红河哈尼族彝族自治州",
    5326: "文山壮族苗族自治州",
    5327: "普洱市", // 现普洱市
    5328: "西双版纳傣族自治州",
    5329: "大理白族自治州",
    5330: "保山市", // 现保山市
    5331: "德宏傣族景颇族自治州",
    5332: "丽江市", // 现丽江市
    5333: "怒江傈僳族自治州",
    5334: "迪庆藏族自治州",
    5335: "临沧市", // 现临沧市

    // 西藏自治区
    5401: "拉萨市",
    5402: "日喀则市",
    5403: "昌都市",
    5404: "林芝市",

    // 陕西省
    6101: "西安市",
    6102: "铜川市",
    6103: "宝鸡市",
    6104: "咸阳市",
    6105: "渭南市",
    6106: "延安市",
    6107: "汉中市",
    6108: "榆林市",
    6109: "安康市",
    6110: "商洛市",
    
    // 陕西省旧代码
    6121: "渭南市", // 现渭南市
    6123: "汉中市", // 现汉中市
    6124: "安康市", // 现安康市
    6125: "商洛市", // 现商洛市
    6126: "延安市", // 现延安市
    6127: "榆林市", // 现榆林市

    // 甘肃省
    6201: "兰州市",
    6202: "嘉峪关市",
    6203: "金昌市",
    6204: "白银市",
    6205: "天水市",
    6206: "武威市",
    6207: "张掖市",
    6208: "平凉市",
    6209: "酒泉市",
    6210: "庆阳市",
    
    // 甘肃省旧代码
    6221: "酒泉市", // 现酒泉市
    6222: "张掖市", // 现张掖市
    6223: "武威市", // 现武威市
    6224: "定西市", // 现定西市
    6226: "陇南市", // 现陇南市
    6227: "平凉市", // 现平凉市
    6228: "庆阳市", // 现庆阳市
    6229: "临夏回族自治州",
    6230: "甘南藏族自治州",

    // 青海省
    6301: "西宁市",
    6321: "海东市",
    
    // 青海省旧代码
    6322: "海北藏族自治州",
    6323: "黄南藏族自治州",
    6325: "海南藏族自治州",
    6326: "果洛藏族自治州",
    6327: "玉树藏族自治州",
    6328: "海西蒙古族藏族自治州",

    // 宁夏回族自治区
    6401: "银川市",
    6402: "石嘴山市",
    6403: "吴忠市",
    6404: "固原市",
    6405: "中卫市",
    
    // 宁夏旧代码
    6421: "吴忠市", // 现吴忠市
    6422: "固原市", // 现固原市

    // 新疆维吾尔自治区
    6501: "乌鲁木齐市",
    6502: "克拉玛依市",
    6504: "吐鲁番市",
    6505: "哈密市",
    
    // 新疆旧代码
    6521: "吐鲁番市", // 现吐鲁番市
    6522: "哈密市", // 现哈密市
    6523: "昌吉回族自治州",
    6527: "博尔塔拉蒙古自治州",
    6528: "巴音郭楞蒙古自治州",
    6529: "阿克苏地区",
    6530: "克孜勒苏柯尔克孜自治州",
    6531: "喀什地区",
    6532: "和田地区",
    6540: "伊犁哈萨克自治州",
    6541: "伊犁地区", // 已撤销
    6542: "塔城地区",
    6543: "阿勒泰地区",
  },
};